import { isDev } from "./host";

export const FILE_UPLOAD_URL = `https://api.unifylist.com/ud_service/v1/file/upload`;

export const GQL_URI = `https://${isDev ? "dev" : ""}api.unifylist.com/api_gateway`;

export const GOOGLE_MAPS_API_KEY = "AIzaSyDOW1qDSuwlibtnDyz1aFZCEkdQKLOEhsg";
